const modalStepsEnum = {
  DELIVERY_METHOD: 'DELIVERY_METHOD',
  DELIVERY_PLACE: 'DELIVERY_PLACE',
  DELIVERY_TIMEFRAME: 'DELIVERY_TIMEFRAME',
} as const;

export default modalStepsEnum;

export type ModalStepsEnumType = (typeof modalStepsEnum)[keyof typeof modalStepsEnum];
